module.exports = __webpack_public_path__ + "static/media/ic_bank_partial_add.da41940b.svg";